import React from "react";
import { ROADMAP_JOURNEY_HIGHLIGHTS } from "../../../data/roadmapData";

const icons = [
  "fas fa-flag",
  "fas fa-book",
  "fas fa-gamepad",
  "fas fa-city",
  "fas fa-bolt",
  "fas fa-crown",
];

const HomeRpgJourneyRoadmap = () => {
  return (
    <section className="td-rpg-section td-rpg-journey" aria-labelledby="td-journey-heading">
      <div className="td-rpg-inner">
        <div className="td-rpg-section__head">
          <div className="td-rpg-ornament" />
          <p className="td-rpg-section__kicker" id="td-journey-heading">
            THE JOURNEY AHEAD
          </p>
          <h2 className="td-rpg-section__title">STRATEGIC MILESTONES</h2>
        </div>

        <div className="td-rpg-timeline">
          <div className="td-rpg-timeline__track">
            {ROADMAP_JOURNEY_HIGHLIGHTS.map((m, i) => (
              <div key={m.title} className="td-rpg-milestone">
                <div className="td-rpg-milestone__node">
                  <i className={icons[i % icons.length]} aria-hidden />
                </div>
                <div className="td-rpg-milestone__phase">{m.phase}</div>
                <div className="td-rpg-milestone__title">{m.title}</div>
                <p>{m.blurb}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeRpgJourneyRoadmap;
